import { useTranslation } from 'react-i18next';

import { toShortDate } from '@/lib/time';
import type { IncidentArchiveFilters } from './filters';

export type IncidentArchiveFiltersSummaryProps = {
  filters: IncidentArchiveFilters;
};

export function IncidentArchiveFiltersSummary({ filters }: IncidentArchiveFiltersSummaryProps) {
  const { t, i18n } = useTranslation();
  const shortDate = (date: Date): string => toShortDate(date, i18n.language);

  return (
    <div className="small d-flex flex-wrap justify-content-center gap-1">
      <span>{t('IncidentArchive_Filters_Incidents_Label')}</span>

      {filters.from != null && (
        <>
          <span>{t('IncidentArchive_Filters_DateFrom_Label')}</span>
          <strong>{shortDate(filters.from)}</strong>
        </>
      )}

      {filters.to != null && (
        <>
          <span>{t('IncidentArchive_Filters_DateTo_Label')}</span>
          <strong>{shortDate(filters.to)}</strong>
        </>
      )}

      {(filters.phoneNumber != null || filters.callerName != null) && (
        <span>{t('IncidentArchive_Filters_Where_Label')}</span>
      )}

      {filters.phoneNumber != null && (
        <>
          <span>{t('IncidentArchive_Filters_PhoneNumber_Label')}</span>
          <strong>{filters.phoneNumber}</strong>
        </>
      )}

      {filters.phoneNumber != null && filters.callerName != null && (
        <span>{t('IncidentArchive_Filters_And_Label')}</span>
      )}

      {filters.callerName != null && (
        <>
          <span>{t('IncidentArchive_Filters_CallerName_Label')}</span>
          <strong>{filters.callerName}</strong>
        </>
      )}

      {filters.note != null && (
        <>
          {(filters.phoneNumber != null || filters.callerName != null) && (
            <span>{t('IncidentArchive_Filters_And_Label')}</span>
          )}
          <span>{t('IncidentArchive_Filters_DispatcherNote_Label')}</span>
          <strong>{filters.note}</strong>
        </>
      )}
    </div>
  );
}
